/**
 * Onboarding API service file
 *
 * @package    src/services
 * @author     PeterTuring <peter.a@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    1.0
 */
import axios from 'axios'
import { ApiConstant } from '../constants'


export function getTalentInformationForHomePage() {
    const token = localStorage.getItem('token');

    if (token) {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }

        return axios.get(`${ApiConstant.BASE_URL}talent/information-for-homepage`, { headers });
    } else {
        return Promise.reject(new Error('Expected token'));
    }
}